import React from "react"
import Link from "../link"
import PeopleCircle from "../icons/people-circle"
import EyeOpen from "../icons/eye-open"
import CalendarClock from "../icons/calendar-clock"
import BubbleMessage from "../icons/bubble-message"
import Avatar from "../avatar"

type CommunityCardProps = {
  user: { name: string; avatar?: string }
  description: string
  activityFromNow: string
  repliesCount: number
  slug: string
  topicId: number
  tags: string[]
  views: number
}
const CommunityCard = ({
  user: { name, avatar },
  description,
  activityFromNow,
  repliesCount,
  slug,
  topicId,
  tags,
  views,
}: CommunityCardProps) => {
  const containsTags = Array.isArray(tags) && tags.length > 0
  return (
    <Link
      to={`/community/t/${slug}/${topicId}/`}
      external
      className="snap-center"
    >
      <div className="p-4 rounded-2xl	bg-neutral-2 flex flex-col-reverse gap-4 w-[328px] lg:w-full lg:flex-col lg:gap-1 hover:bg-neutral-3 cursor-pointer">
        <div className="flex flex-col lg:flex-row gap-4 lg:justify-between text-neutral-11">
          <div className="flex-grow text-jar-4 font-medium text-neutral-12">
            {description}
          </div>
          <div className="flex flex-row gap-1.5  items-center w-full lg:w-[180px] justify-start lg:justify-end">
            <p className="order-2 lg:order-1 text-jar-3 font-medium">{name}</p>
            {avatar ? (
              <Avatar
                src={avatar}
                className="size-5 shink-0 order-1 lg:order-2"
              />
            ) : (
              <PeopleCircle className="shink-0 order-1 lg:order-2" />
            )}
          </div>
          <div className="flex gap-3 lg:gap-4 items-center">
            <div className="flex-1 lg:w-[110px] flex flex-row gap-1.5 items-center lg:justify-end">
              <p className="order-2 lg:order-1 text-jar-3 font-medium ">
                {views || 0}
              </p>
              <EyeOpen className="shink-0 order-1 lg:order-2" />
            </div>
            <div className="flex-1 lg:w-[110px] flex flex-row gap-1.5 items-center lg:justify-end">
              <p className="order-2 lg:order-1 text-jar-3 font-medium line-clamp-1 text-ellipsis">
                {activityFromNow}
              </p>
              <CalendarClock className="shrink-0 order-1 lg:order-2" />
            </div>
            <div className="flex-1 lg:w-[110px] flex flex-row gap-1.5 items-center lg:justify-end">
              <p className="order-2 lg:order-1 text-jar-3 font-medium">
                {repliesCount}
              </p>
              <BubbleMessage className="shrink-0 order-1 lg:order-2" />
            </div>
          </div>
        </div>

        {containsTags && (
          <div className="text-[#0D59E8] text-jar-3 gap-1.5 flex items-center">
            <div className="size-[6.67px] bg-[#0D59E8] rounded-full" />
            {tags.map((tag, index) => (
              <span key={tag}>
                {index < tags.length - 1 ? `${tag}, ` : `${tag}`}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  )
}

export { CommunityCard }
